import React, { useState } from 'react';
import axios from 'axios';
import { Layers } from 'lucide-react';

function AddCategoryForm({ onSuccess }) {
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!name.trim()) {
      return alert('El nombre es requerido');
    }

    setLoading(true);
    try {
      const payload = {
        name: name.trim(),
        parent_id: null,
        slug: slug.trim() || undefined
      };

      const baseUrl = process.env.REACT_APP_API_URL || '';
      const res = await axios.post(`${baseUrl}/api/create_category`, payload);
      
      alert(`Categoría creada con ID ${res.data.id}`);
      setName('');
      setSlug('');
      onSuccess();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Error al crear categoría');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-slate-900 font-montserrat flex items-center gap-2">
          <Layers className="w-5 h-5 text-[#B1336E]" />
          Nueva Categoría
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-slate-700 font-montserrat mb-2">
            Nombre de Categoría *
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Ej: Electrónicos"
            className="w-full px-3 py-2 border-2 border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-slate-700 font-montserrat mb-2">
            Slug (opcional)
          </label>
          <input
            type="text"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            placeholder="Ej: electronicos"
            className="w-full px-3 py-2 border-2 border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat text-sm"
          />
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="submit"
            disabled={loading}
            className="flex-1 bg-gradient-to-r from-[#B1336E] to-[#E6B43C] text-white font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-montserrat"
          >
            {loading ? 'Guardando...' : 'Guardar Categoría'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddCategoryForm;